import { useEffect, useState } from "react";


import InstructionsDetails from "components/InstructionsDetails";
import { useOptionContext } from "context/OptionContext";
import { t } from "i18next";
import {
  applyAttachmentInclusionRule,
  applyAttachmentAdjustments,
  buildQuoteSummary,
  calculateSummaryTotal,
} from "services/quoteRuntime";
import {
  Attachment,
  AttachmentAdjustments,
  FinalCost,
  Material,
  Province,
} from "types/canvasTypes";

import ClientForm from "../ClientForm";
import QuotationTable from "../QuotationTable";

const StepThree = () => {
  const [globalCheckbox, setCheckBox] = useState(true);
  const [finalCost, setFinalCost] = useState<FinalCost[]>([]);
  const [totalCost, setTotalCost] = useState(0);
  const [material, setMaterial] = useState<Attachment[]>([]);
  const [attachmentAdjustments, setAttachmentAdjustments] =
    useState<AttachmentAdjustments>({});

  const { materialType, height, scale, lines, province, chalkLine, gapSize } =
    useOptionContext();

  useEffect(() => {
    setAttachmentAdjustments({});
  }, [materialType, height, scale, lines, globalCheckbox, chalkLine, gapSize, province]);

  useEffect(() => {
    const { finalCost, attachment } = buildQuoteSummary({
      lines,
      glassHeight: height,
      scale,
      chalkLine,
      gapSize,
      materialType,
      includeAttachments: globalCheckbox,
      hasDoubleDoor: lines.some((line) => line.numberOfDoors > 1),
      province,
    });

    if (finalCost) {
      const filteredAttachment = applyAttachmentInclusionRule(
        attachment,
        globalCheckbox
      );
      const adjustedAttachment = applyAttachmentAdjustments(
        filteredAttachment,
        attachmentAdjustments
      );

      setFinalCost(finalCost);
      setMaterial(adjustedAttachment);
      setTotalCost(
        calculateSummaryTotal(
          finalCost,
          adjustedAttachment,
          materialType,
          province
        )
      );
    }
  }, [
    attachmentAdjustments,
    materialType,
    height,
    scale,
    lines,
    globalCheckbox,
    chalkLine,
    gapSize,
    province,
  ]);

  const handleAttachmentCountChange = (
    attachmentMaterial: Material,
    delta: number
  ) => {
    setAttachmentAdjustments((previousAdjustments) => {
      const currentCount =
        material.find((item) => item.material === attachmentMaterial)?.count || 0;

      if (delta < 0 && currentCount <= 0) {
        return previousAdjustments;
      }

      return {
        ...previousAdjustments,
        [attachmentMaterial]:
          (previousAdjustments[attachmentMaterial] || 0) + delta,
      };
    });
  };

  return (
    <div className="step-container">
      <h1>{t("thirdStep")}</h1>
      {province === Province.Quebec && (
        <InstructionsDetails title={t("instructions")}>
          <p>{t("instructionsText")}</p>
          <p>{t("instructionsText2")}</p>
        </InstructionsDetails>
      )}
      <div id="sidesInformation" style={{ width: "100%" }}>
        <div className="flex-between" style={{ width: "100%", gap: "10px" }}>

          <h3>{t("details")}</h3>
          <button
            id="myCheckbox"
            name="myCheckbox"
            className={globalCheckbox ? "delete-button" : ""}
            onClick={() => setCheckBox((globalCheckbox) => !globalCheckbox)}
          >
            {globalCheckbox ? t("removeConnectors") : t("includeConnectors")}
          </button>
        </div>
        <QuotationTable
          province={province}
          selectedLength={height}
          finalCost={finalCost}
          materialOption={materialType}
          material={material}
          totalCost={totalCost}
          editableAttachments={true}
          onAttachmentCountChange={handleAttachmentCountChange}
        />
        <ClientForm
          lines={lines}
          material={materialType}
          attachmentAdjustments={attachmentAdjustments}
          selectedLength={`${height}`}
          scale={scale}
          includeAttachement={globalCheckbox}
        />
      </div>
    </div>
  );
};
export default StepThree;
